import { styled } from "baseui";

export const Body = styled("p", ({ $theme }) => ({
  ...$theme.typography.body,
  color: $theme.colors.contentPrimary,
}));

export const MonoBody = styled("p", ({ $theme }) => ({
  ...$theme.typography.MonoLabelMedium,
  color: $theme.colors.contentPrimary,
}));
